__turbopack_context__.v({
  "actionRow": "_8fpEja_actionRow",
  "closeButton": "_8fpEja_closeButton",
  "content": "_8fpEja_content",
  "emptyContent": "_8fpEja_emptyContent",
  "emptyDescription": "_8fpEja_emptyDescription",
  "emptyIllustration": "_8fpEja_emptyIllustration",
  "emptyState": "_8fpEja_emptyState",
  "emptyTitle": "_8fpEja_emptyTitle",
  "footer": "_8fpEja_footer",
  "header": "_8fpEja_header",
  "markAllButton": "_8fpEja_markAllButton",
  "notLoggedInButtons": "_8fpEja_notLoggedInButtons",
  "notLoggedInContent": "_8fpEja_notLoggedInContent",
  "notLoggedInDescription": "_8fpEja_notLoggedInDescription",
  "notLoggedInIllustration": "_8fpEja_notLoggedInIllustration",
  "notLoggedInState": "_8fpEja_notLoggedInState",
  "notLoggedInText": "_8fpEja_notLoggedInText",
  "notLoggedInTitle": "_8fpEja_notLoggedInTitle",
  "notificationsList": "_8fpEja_notificationsList",
  "overlay": "_8fpEja_overlay",
  "panel": "_8fpEja_panel",
  "signInButton": "_8fpEja_signInButton",
  "signUpLink": "_8fpEja_signUpLink",
  "signUpRow": "_8fpEja_signUpRow",
  "signUpText": "_8fpEja_signUpText",
  "srOnly": "_8fpEja_srOnly",
  "title": "_8fpEja_title",
  "titleRow": "_8fpEja_titleRow",
  "viewAllLink": "_8fpEja_viewAllLink",
  "viewEmptyAction": "_8fpEja_viewEmptyAction",
  "viewEmptyBody": "_8fpEja_viewEmptyBody",
  "viewEmptyState": "_8fpEja_viewEmptyState",
  "viewEmptyTitle": "_8fpEja_viewEmptyTitle",
});
